export const DESIGNATION_LABELS = {
  CEO: "CEO", Admin: "Admin", CSM: "Client Success Manager",
  CM: "Campaign Manager", Manager: "Sales Manager", Client: "Client",
};

export const formatDesignation = (code) => {
  if (!code) return code;
  return String(code)
    .split(",")
    .map((c) => DESIGNATION_LABELS[c.trim()] || c.trim())
    .join(" + ");
};